<dx-box
    #searchBoxContainer
    height="100%"
    width="100%"
    direction="col"
    class="cc-search-container"
    [elementAttr]="{ id: 'searchBoxContainer' + (!widgetId ? '' : widgetId) }"
>
    <dxi-item baseSize="auto" [visible]="!hideTitle">
        <h2 class="page-header" [ngClass]="{ 'cc-text-center': isSmallScreen }">
            Search
            <sup class="page-help-link">
                <a [href]="helpLink" target="_blank" class="fas fa-question-circle"></a>
            </sup>
        </h2>
    </dxi-item>
    <dxi-item [ratio]="1" class="search-container cc-white-background">
        <dx-box height="100%" width="100%" direction="col">
            <!-- Show this filter section when search component is being shown on its specific route -->
            <dxi-item baseSize="auto" *ngIf="!widgetId">
                <dx-form width="80%" height="100%" [colCount]="5">
                    <dxi-item [colSpan]="2">
                        <dxo-label text="Search Type"></dxo-label>
                        <div *dxTemplate>
                            <dx-select-box
                                width="100%"
                                displayExpr="displayText"
                                valueExpr="code"
                                [searchEnabled]="true"
                                [dataSource]="searchTypes"
                                [(value)]="selectedSearchTypeCode"
                                (onValueChanged)="onSearchTypeChanged()"
                            ></dx-select-box>
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="3">
                        <dxo-label text="Community"></dxo-label>
                        <div *dxTemplate>
                            <app-multi-column-selector
                                #communitySelector
                                [name]="'Community'"
                                [gridSource]="communityList"
                                [boxValue]="communityGridBoxValue"
                                [valueExpr]="'communityId'"
                                [displayExpr]="'communityName'"
                                [columnDef]="communityColumns"
                                [dropDownButtonTemplate]="'dropDownButton'"
                                [dropDownOptions]="{ width: 'auto' }"
                                [showClearButton]="true"
                                [navigateToCommunity]="true"
                                [placeholder]="'Select Community...'"
                                [showHeaderFilters]="true"
                                (gridSelectionEvent)="onCommunitySelection($event)"
                            ></app-multi-column-selector>
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="2" [isRequired]="true">
                        <dxo-label text="Search For"></dxo-label>
                        <div *dxTemplate>
                            <dx-text-box
                                width="100%"
                                (onEnterKey)="onSearchClick()"
                                [(value)]="searchText"
                                (onKeyUp)="onSearchTextboxKeyUp($event)"
                            ></dx-text-box>
                        </div>
                    </dxi-item>
                    <dxi-item *ngIf="showDateFields()">
                        <dxo-label text="From"></dxo-label>
                        <div *dxTemplate>
                            <dx-date-box type="date" [width]="100" [(value)]="startDate"></dx-date-box>
                        </div>
                    </dxi-item>
                    <dxi-item *ngIf="showDateFields()">
                        <dxo-label text="To"></dxo-label>
                        <div *dxTemplate>
                            <dx-date-box type="date" [width]="120" [(value)]="endDate"></dx-date-box>
                        </div>
                    </dxi-item>
                    <dxi-item
                        itemType="button"
                        [horizontalAlignment]="isSmallScreen ? 'center' : 'left'"
                        [buttonOptions]="{
                            type: 'default',
                            text: 'Search',
                            icon: searchIcon,
                            width: 110,
                            onClick: onSearchClick,
                            useSubmitBehavior: true
                        }"
                    ></dxi-item>
                    <dxi-item itemType="empty" [colSpan]="4" [visible]="!isSmallScreen"></dxi-item>
                </dx-form>
            </dxi-item>

            <!-- Show this filter section when search component is being shown in workspace as widget -->
            <dxi-item baseSize="auto" *ngIf="!!widgetId">
                <dx-form width="100%" height="100%">
                    <dxi-item itemType="group" [colCount]="filterColCount <= 2 ? 1 : 2">
                        <dxi-item>
                            <dxo-label text="Search Type"></dxo-label>
                            <div *dxTemplate>
                                <dx-select-box
                                    width="100%"
                                    displayExpr="displayText"
                                    valueExpr="code"
                                    [searchEnabled]="true"
                                    [dataSource]="searchTypes"
                                    [(value)]="selectedSearchTypeCode"
                                    (onValueChanged)="onSearchTypeChanged()"
                                ></dx-select-box>
                            </div>
                        </dxi-item>
                        <dxi-item [colSpan]="filterColCount <= 2 ? 1 : 2">
                            <dxo-label text="Community"></dxo-label>
                            <div *dxTemplate>
                                <app-multi-column-selector
                                    #communitySelector
                                    cssClass="widget-drop-down-box"
                                    [name]="'Community'"
                                    [gridSource]="communityList"
                                    [boxValue]="communityGridBoxValue"
                                    [valueExpr]="'communityId'"
                                    [displayExpr]="'communityName'"
                                    [columnDef]="communityColumns"
                                    [dropDownButtonTemplate]="'dropDownButton'"
                                    [dropDownOptions]="{ width: 'auto' }"
                                    [showClearButton]="true"
                                    [navigateToCommunity]="true"
                                    [placeholder]="'Select Community...'"
                                    [showHeaderFilters]="true"
                                    (gridSelectionEvent)="onCommunitySelection($event)"
                                ></app-multi-column-selector>
                            </div>
                        </dxi-item>
                    </dxi-item>
                    <dxi-item itemType="group" [colCount]="filterColCount">
                        <dxi-item [colSpan]="getSearchForColColunt()" [isRequired]="true">
                            <dxo-label text="Search For"></dxo-label>
                            <div *dxTemplate>
                                <dx-text-box
                                    (onEnterKey)="onSearchClick()"
                                    [(value)]="searchText"
                                    (onKeyUp)="onSearchTextboxKeyUp($event)"
                                ></dx-text-box>
                            </div>
                        </dxi-item>
                        <dxi-item *ngIf="showDateFields()">
                            <dxo-label text="From"></dxo-label>
                            <div *dxTemplate>
                                <dx-date-box type="date" [width]="95" [(value)]="startDate"></dx-date-box>
                            </div>
                        </dxi-item>
                        <dxi-item *ngIf="showDateFields()">
                            <dxo-label text="To"></dxo-label>
                            <div *dxTemplate>
                                <dx-date-box type="date" [width]="95" [(value)]="endDate"></dx-date-box>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <div *dxTemplate [ngClass]="filterColCount == 2 ? 'cc-text-right' : 'cc-text-left'">
                                <dx-button
                                    type="default"
                                    hint="Search"
                                    text="Search"
                                    [icon]="searchIcon"
                                    (onClick)="onSearchClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dxi-item>
                </dx-form>
            </dxi-item>

            <dxi-item [ratio]="1" class="grid-container">
                <dx-multi-view
                    width="100%"
                    height="100%"
                    [swipeEnabled]="false"
                    [animationEnabled]="true"
                    [dataSource]="searchTypes"
                    [selectedIndex]="0"
                >
                    <div *dxTemplate="let types of 'item'">
                        <app-search-properties-current-owners
                            #currentOwners
                            [searchText]="searchText"
                            [communityId]="communityId"
                            [isQuickSearch]="false"
                            [widgetId]="widgetId"
                            *ngIf="searchType.propertiesCurrentOwners === selectedSearchTypeCode"
                        ></app-search-properties-current-owners>
                        <app-search-properties-all-owners
                            #allOwners
                            [searchText]="searchText"
                            [communityId]="communityId"
                            [widgetId]="widgetId"
                            *ngIf="searchType.propertiesAllOwners === selectedSearchTypeCode"
                        ></app-search-properties-all-owners>
                        <app-search-project-tasks
                            #projectTasks
                            [searchText]="searchText"
                            [communityId]="communityId"
                            [startDate]="startDate"
                            [endDate]="endDate"
                            [widgetId]="widgetId"
                            *ngIf="searchType.projectTasks === selectedSearchTypeCode"
                        ></app-search-project-tasks>
                        <app-search-work-orders
                            #workOrders
                            [searchText]="searchText"
                            [communityId]="communityId"
                            [startDate]="startDate"
                            [endDate]="endDate"
                            [widgetId]="widgetId"
                            *ngIf="searchType.workOrders === selectedSearchTypeCode"
                        ></app-search-work-orders>
                        <app-search-vendor-disbursements-check
                            #vendorDisbursementsCheck
                            [searchText]="searchText"
                            [communityId]="communityId"
                            [widgetId]="widgetId"
                            *ngIf="searchType.vendorDisbursementsCheck === selectedSearchTypeCode"
                        ></app-search-vendor-disbursements-check>
                        <app-search-invoices-workflow
                            #invoicesWorkflow
                            [searchText]="searchText"
                            [communityId]="communityId"
                            [startDate]="startDate"
                            [endDate]="endDate"
                            [widgetId]="widgetId"
                            *ngIf="searchType.invoicesWorkflow === selectedSearchTypeCode"
                        ></app-search-invoices-workflow>
                        <app-search-violation-notices
                            #violationNotices
                            [searchText]="searchText"
                            [communityId]="communityId"
                            [widgetId]="widgetId"
                            *ngIf="searchType.violationNotices === selectedSearchTypeCode"
                        ></app-search-violation-notices>
                        <app-search-vendors
                            #vendors
                            [searchText]="searchText"
                            [communityId]="communityId"
                            [widgetId]="widgetId"
                            *ngIf="searchType.vendors === selectedSearchTypeCode"
                        ></app-search-vendors>
                        <app-search-architectural-applications
                            #architecturalApplications
                            [searchText]="searchText"
                            [communityId]="communityId"
                            [widgetId]="widgetId"
                            *ngIf="searchType.architecturalApplications === selectedSearchTypeCode"
                        ></app-search-architectural-applications>
                    </div>
                </dx-multi-view>
            </dxi-item>
        </dx-box>
    </dxi-item>
</dx-box>

<dx-load-panel
    [position]="{ of: !widgetId ? 'body' : '#searchBoxContainer' + widgetId }"
    *ngIf="loadingVisible"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="!widgetId"
    [shading]="!widgetId"
    [closeOnOutsideClick]="false"
></dx-load-panel>
